import { customFetch } from '../lib/network/Axios';
import type {
  AdminCreateKioskRegistrationPayload,
  AdminCreateKioskRegistrationResponse,
  KioskRegistrationDetail,
  KioskRegistrationListParams,
  KioskRegistrationListResponse,
  OwnerOnboarding,
  RejectRegistrationPayload,
  SendProposalPayload,
  TermsSignedPayload,
} from '../types/kioskRegistration.types';

const BASE = '/kiosk-registrations';

export async function getKioskRegistrations(
  params: KioskRegistrationListParams,
): Promise<KioskRegistrationListResponse> {
  const response = await customFetch.get(BASE, {
    params: { ...params, search: params.search?.trim() || undefined },
  });
  return response.data as KioskRegistrationListResponse;
}

export async function getKioskRegistration(id: number): Promise<KioskRegistrationDetail> {
  const response = await customFetch.get(`${BASE}/${id}`);
  return response.data as KioskRegistrationDetail;
}

export async function createAdminKioskRegistration(
  payload: AdminCreateKioskRegistrationPayload,
): Promise<AdminCreateKioskRegistrationResponse> {
  const response = await customFetch.post(`${BASE}/admin`, payload);
  return response.data as AdminCreateKioskRegistrationResponse;
}

export async function uploadKioskRegistrationImage(file: File): Promise<string> {
  const formData = new FormData();
  formData.append('image', file);
  const response = await customFetch.post(`${BASE}/uploads`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return (response.data as { url: string }).url;
}

export async function approveKioskRegistration(id: number, body: { note?: string }) {
  await customFetch.post(`${BASE}/${id}/approve`, body);
}

export async function rejectKioskRegistration(id: number, body: RejectRegistrationPayload) {
  await customFetch.post(`${BASE}/${id}/reject`, body);
}

export async function cancelKioskRegistration(id: number, body: { reason: string }) {
  await customFetch.post(`${BASE}/${id}/cancel`, body);
}

export async function markKioskRegistrationCallCompleted(id: number, body: { notes?: string }) {
  await customFetch.post(`${BASE}/${id}/call-completed`, body);
}

export async function sendKioskRegistrationProposal(id: number, body: SendProposalPayload) {
  await customFetch.post(`${BASE}/${id}/send-proposal`, body);
}

export async function markKioskRegistrationTermsSigned(id: number, body: TermsSignedPayload) {
  await customFetch.post(`${BASE}/${id}/terms-signed`, body);
}

export async function markKioskRegistrationPaymentReceived(id: number, body: { notes?: string }) {
  await customFetch.post(`${BASE}/${id}/payment-received`, body);
}

export async function resendKioskRegistrationWelcome(id: number) {
  await customFetch.post(`${BASE}/${id}/resend-welcome`);
}

export async function getMyOnboarding(): Promise<OwnerOnboarding> {
  const response = await customFetch.get(`${BASE}/me/onboarding`);
  return response.data as OwnerOnboarding;
}
